import AlertHexagonIcon from "@redotech/redo-icons/alert-hexagon_filled.svg";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ProblemOrderWarningModal = memo(function ProblemOrderWarningModal({
  isOpen,
  fulfillmentGroupId,
  onContinue,
  onGoToProblemOrders,
  onScanNext,
}: {
  isOpen: boolean;
  fulfillmentGroupId: string;
  onContinue: () => void;
  onGoToProblemOrders: (fulfillmentGroupId: string) => void;
  onScanNext: () => void;
}) {
  return (
    <RedoModal
      footerLayout="column"
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={onContinue}
      primaryButton={{
        text: "Continue packing",
        onClick: onContinue,
        size: "md",
      }}
      secondaryButton={{
        text: "Scan next order/tote",
        onClick: onScanNext,
        size: "md",
      }}
      theme="error"
      title="Problem order"
      TitleIcon={AlertHexagonIcon}
    >
      <Flex dir="column" gap="sm">
        <Text>
          This is a problem order. If items are missing, please deliver the tote
          to troubleshooting.
        </Text>
        <Text
          cursor="pointer"
          onClick={() => onGoToProblemOrders(fulfillmentGroupId)}
          textDecoration="underline"
        >
          View details
        </Text>
      </Flex>
    </RedoModal>
  );
});
